module.exports = __webpack_public_path__ + "static/media/lixCare.cdeab23f.png";